export default __webpack_public_path__ + "static/media/react.a2ab6c4d.png";